import _ from 'lodash'

export const splitServicesList = (services) => {
  const splitedServices = _.partition(services, (service) => {
    return !!service.additional
  })
  return {
    mainServices: splitedServices[1],
    additionalServices: splitedServices[0]
  }
}

export const splitServiceName = (service) => {
  return service?.split('&').join(' & ')
}

export const shortServiceName = (serviceName) => {
  if (!serviceName) return ''

  return serviceName?.length > 14
    ? serviceName?.substring(0, 14) + '.'
    : serviceName
}
